module.exports = __webpack_public_path__ + "img/职工4级@3x.16b42ad9.png";